import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import DateFilter from "@/lib/filters/date/date-filter";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import {reviewDataQueryOptions} from "@/modules/reviews/hooks";
import ReviewDataTable from "@/modules/reviews/review-data-table";
import {
  defaultFetchParamsReviewData, mergedReviewDataSchema,
  ReviewDataSearch
} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {REVIEWS_PATH, REVIEWS_URL} from "@/utils/urls";

export const Route = createFileRoute(REVIEWS_PATH)({
  component: Reviews,
  validateSearch: (search: Record<string, unknown>): ReviewDataSearch => validateSearchWithDefaults(mergedReviewDataSchema, search),
  loader: ({ context: { queryClient, date } }: DataLoader) => {
    if (isCurrentPage(REVIEWS_URL)) {
      return
    }
    queryClient.prefetchQuery(reviewDataQueryOptions(date, defaultFetchParamsReviewData))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [{ label: 'Reviews', path: REVIEWS_URL}],
      children: <DateFilter />
    }
  },
})

function Reviews() {
  return(
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[ROLES.ROLE_EDIT_FIRM, ROLES.ROLE_VIEW_FIRM]} permissions={[]} forbiddenFallback={<Unauthorized />}>
        <ReviewDataTable />
      </Authorisation>
    </div>
  )
}
